
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastService } from 'src/app/shared/services/toast.service';
import { DcrDrug } from '../../models/drug';
import { RpoToolService } from '../../services/rpo-tool.service';
import * as constants from 'src/app/config/app-constants';
import { MatLegacyPaginator as MatPaginator, LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { routePaths } from 'src/app/config/app-constants';
import { Router } from '@angular/router';
import { ImportWizardDrugClassificationResolutionComponent } from './../import-wizard-drug-classification-resolution/import-wizard-drug-classification-resolution.component';

@Component({
  selector: 'app-import-wizard-dcr-drug-list',
  standalone: false,
  templateUrl: './import-wizard-dcr-drug-list.component.html',
  styleUrl: './import-wizard-dcr-drug-list.component.scss'
})
export class ImportWizardDcrDrugListComponent implements OnInit {

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  displayedColumns = ['strength', 'drugNumber', 'priority','dcrAge', 'status', 'caseOwner', 'caseSource', 'manufacturer','caseNumber','action'];
  selectedRow:any;
  dataSource= new MatTableDataSource<DcrDrug>();
     totalRows: number = 0;
     currentPage: number = 1;
     pageSize: number = 10;
     pageSizeOptions: number[] = [50, 100, 200, 500];
     isCaseNoShow: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<ImportWizardDcrDrugListComponent>,
    public dialog: MatDialog,
    private rpoService:RpoToolService,
    private ngxLoader: NgxUiLoaderService,
    private route: Router,
    private toastService: ToastService) {}

  ngOnInit(): void {
    this.getDrugData();
  }
  pageChanged(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getDrugData();
  }
  redirectToDetailsPage(rowId:any,dataSourceId:number){
    this.route.navigate([`/${routePaths.DRUG_MANAGEMENT}/drug-details`, rowId,dataSourceId]);
    this.dialogRef.close();
  }
  getDrugData(){
    let dcrKey = 'dcrKey'
    this.ngxLoader.start(dcrKey);
    this.rpoService.getDcrDrugs(
      this.currentPage == 0 ? 1 : this.currentPage,
       this.pageSize,
    ).subscribe((response)=>{
      let result = response.data;
      this.ngxLoader.stop(dcrKey);
     this.dataSource.data = result.drugs
     setTimeout(() => {
      this.paginator.pageIndex = this.currentPage;
      this.paginator.length = result.totalRows;
    });
    },
    (error: HttpErrorResponse) => {
      this.ngxLoader.stop(dcrKey);
      console.log(error);
      this.toastService.openToast(
        error.message,
        constants.ToastPanelType.error,
        2
      );
    })
  }

   openImportWizardDcrDetails(caseNo:any) {
      const dialogRef = this.dialog.open(ImportWizardDrugClassificationResolutionComponent, {
        backdropClass: ['lgDialog'],
        disableClose: true,
        data: {
          caseNo: caseNo
        }
      });
  
    }

}

